import { ButtonWrapper } from "@eisinc/MobiusOverrides/Button";
import { headerShipToAddressStyles } from "@eisinc/Overrides/Widgets/Common/HeaderShipToAddress";
import { color } from "@eisinc/XDL/Utilities";
import { mergeWithCss } from "@eisinc/XDL/Utilities/mergeWithCss";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

headerShipToAddressStyles.titleTypography = {
    css: css`
        margin-left: 10px;
        width: 100%;
        white-space: nowrap;
    `,
    transform: "uppercase",
};

headerShipToAddressStyles.shipToAddressWrapper = {
    ...mergeWithCss(headerShipToAddressStyles.shipToAddressWrapper, {
        css: css`
            gap: 8px;
            align-items: center;
            height: 30px;
        `,
    }),
};

headerShipToAddressStyles.shipToSelector = {
    cssOverrides: {
        wrapper: css`
            width: 100%;
            height: auto;

            ${ButtonWrapper} {
                width: 100%;
                background: transparent;
                height: 30px;
                min-height: 30px;
                border: none;
                min-width: 175px;
                ${TypographyStyle} {
                    height: 18px;
                    line-height: 22px;
                }
            }
        `,
        menu: css`
            width: auto;
            max-width: 90%;
            background: ${color("common.ui3")};
            border-top: 1px solid ${color("primary.main")};
            border-radius: 8px;
            left: auto !important;
        `,
    },
};

headerShipToAddressStyles.iconWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
        padding: 3px 8px;
        ${({ isOpen }: any) => {
            if (isOpen) {
                return css`
                    border: 2px solid ${color("common.border")};
                `;
            }
        }}
    `,
};

headerShipToAddressStyles.arrowIcon = {
    size: 15,
    css: css`
        ${({ isOpen }: any) => {
            if (isOpen) {
                return css`
                    transform: rotate(180deg);
                `;
            }
        }}
    `,
};

headerShipToAddressStyles.fulfillmentWrapper = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        padding: 4px 8px;
    `,
};

headerShipToAddressStyles.fulfillmentLink = {
    css: css`
        && {
            width: max-content;
            padding: 0;
            white-space: nowrap;
            :hover {
                background: transparent;
            }
            ${TypographyStyle} {
                padding: 0;
                :hover {
                    background: transparent;
                }
            }
        }
    `,
};
